export default __webpack_public_path__ + "static/media/345.a9f3ac79.gif";